export type TColors = typeof colors;
export const colors = {
  // main colors
  primary: "#0E5AA7",
  "primary-active": "#0B4C8E",
  "primary-hover": "#093A6C",
  secondary: "rgba(14, 90, 167, 0.05)",
  "secondary-active": "rgba(14, 90, 167, 0.10)",
  "secondary-hover": "rgba(14, 90, 167, 0.20)",
  transparent: "transparent",
  black: "#000000",
  white: "#FFFFFF",

  // c4-blue color palette
  "c4blue-25": "#F4FBFE",
  "c4blue-50": "#C2D5E8",
  "c4blue-100": "#92B4D7",
  "c4blue-200": "#6293C5",
  "c4blue-300": "#3172B4",
  "c4blue-400": "#0E5AA7",
  "c4blue-500": "#0B4C8E",
  "c4blue-600": "#093A6C",
  "c4blue-700": "#06284B",
  "c4blue-800": "#031629",

  // c4-red color palette
  "c4red-25": "#FEF1F1",
  "c4red-50": "#FAC8C8",
  "c4red-100": "#F79C9D",
  "c4red-200": "#F37172",
  "c4red-300": "#F04547",
  "c4red-400": "#DD2326",
  "c4red-500": "#BC1E20",
  "c4red-600": "#9A1819",
  "c4red-700": "#6B1011",
  "c4red-800": "#3B0909",

  // other brand colors
  mafgold: "#BD9E56",
  sharemaroon: "#8A1538",
  sharegold: "#B4975A",
  sharebrown: "#2F2707",
  shareprimary: "#B5064D",
  shareblue: "#0E5AA70D",
  sharegray: "#D9D9D9",
  sharegraywhite: "F7F8F9",
  sharedarkblue: "#1877F2",
  shareblack: "#000408",
  nightblack: "#1A1A1A",
  sharedeepblue: "#001478",
  "profile-blue": "#1271D2",
  "profile-gray": "#F7F8F9",
  "whatsapp-green": "#25D366",

  // gold color palette
  "gold-25": "#FDF8F2",
  "gold-50": "#F7E0C2",
  "gold-100": "#F2C892",
  "gold-200": "#ECB062",
  "gold-300": "#E79832",
  "gold-400": "#E3870F",
  "gold-500": "#C1720C",
  "gold-600": "#935709",
  "gold-700": "#663C06",
  "gold-800": "#382103",

  // yellow color palette
  "yellow-25": "#FFFDF4",
  "yellow-50": "#FFF6C9",
  "yellow-100": "#FFF09E",
  "yellow-200": "#FFEA73",
  "yellow-300": "#FFE348",
  "yellow-400": "#FFDF28",
  "yellow-500": "#D9BD22",
  "yellow-600": "#A6911A",
  "yellow-700": "#736412",
  "yellow-800": "#40370A",

  // persia color palette
  "persia-25": "#E6F4F2",
  "persia-50": "#BFE4E1",
  "persia-100": "#8CCFC9",
  "persia-200": "#59BAB1",
  "persia-300": "#26A599",
  "persia-400": "#009688",
  "persia-500": "#007F73",
  "persia-600": "#006158",
  "persia-700": "#00433D",
  "persia-800": "#002522",

  // madison color palette
  "madison-25": "#F0F3F7",
  "madison-50": "#C1CFDE",
  "madison-100": "#90AAC3",
  "madison-200": "#5F84A9",
  "madison-300": "#2E5F8F",
  "madison-400": "#0A437C",
  "madison-500": "#083969",
  "madison-600": "#062B50",
  "madison-700": "#041E37",
  "madison-800": "#051423",

  // polo color palette
  "polo-25": "#F2F5F8",
  "polo-50": "#DFE8F2",
  "polo-100": "#C5D6E8",
  "polo-200": "#ACC5DE",
  "polo-300": "#92B3D4",
  "polo-400": "#80A6CD",
  "polo-500": "#6C8DAE",
  "polo-600": "#536C85",
  "polo-700": "#394A5C",
  "polo-800": "#202933",

  // minsk color palette
  "minsk-25": "#F5F5F9",
  "minsk-50": "#CDCDE5",
  "minsk-100": "#A6A6D0",
  "minsk-200": "#7F7FBB",
  "minsk-300": "#5858A7",
  "minsk-400": "#3B3B98",
  "minsk-500": "#323281",
  "minsk-600": "#262662",
  "minsk-700": "#1A1A44",
  "minsk-800": "#0E0E26",

  // purple color palette
  "purple-25": "#F6F1F5",
  "purple-50": "#DAC6D7",
  "purple-100": "#BE98B7",
  "purple-200": "#A16B97",
  "purple-300": "#843D77",
  "purple-400": "#6F1C60",
  "purple-500": "#5E1751",
  "purple-600": "#48123E",
  "purple-700": "#320C2B",
  "purple-800": "#1B0718",

  // gray color palette
  "gray-15": "#FAFAFB",
  "gray-25": "#F4F4F4",
  "gray-50": "#EAEAEA",
  "gray-100": "#DCDCDC",
  "gray-200": "#C3C3C3",
  "gray-300": "#B2B2B2",
  "gray-400": "#979797",
  "gray-500": "#747474",
  "gray-600": "#505050",
  "gray-700": "#1F1F1F",
  "gray-800": "#141414",

  // red color palette
  "red-25": "#FDF4F4",
  "red-50": "#FBCFCF",
  "red-100": "#F9A8A9",
  "red-200": "#F78283",
  "red-300": "#F45C5D",
  "red-400": "#F34041",
  "red-500": "#CE3637",
  "red-600": "#9E292A",
  "red-700": "#6D1C1D",
  "red-800": "#3C1010",

  // orange color palette
  "orange-15": "#F1B91A",
  "orange-25": "#FEFCF5",
  "orange-50": "#FCEECF",
  "orange-100": "#FAE0A9",
  "orange-200": "#F7D283",
  "orange-300": "#F5C45D",
  "orange-400": "#F3BA40",
  "orange-500": "#CF9E36",
  "orange-600": "#9E792A",
  "orange-700": "#6D541D",
  "orange-800": "#3D2F10",

  // green color palette
  "green-25": "#E9F6F1",
  "green-50": "#CEEEDB",
  "green-100": "#A6E0BF",
  "green-200": "#7FD2A3",
  "green-300": "#58C486",
  "green-400": "#3ABA71",
  "green-500": "#319E60",
  "green-600": "#267949",
  "green-700": "#1A5433",
  "green-800": "#0F2F1C",

  // blue color palette
  "blue-25": "#F1FAFE",
  "blue-50": "#C7EBF9",
  "blue-100": "#9BDBF4",
  "blue-200": "#6ECCEF",
  "blue-300": "#41BCEA",
  "blue-400": "#20B0E6",
  "blue-500": "#1B96C3",
  "blue-600": "#157296",
  "blue-700": "#0E4F68",
  "blue-800": "#082C39",
};
